import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CustomHttp } from "../../common/customHttp.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ApiUrl } from "../../common/apiUrls";
import { MainAppComponent } from "../../layout/layout.component";
import "rxjs/add/operator/map";
import "rxjs/add/operator/takeUntil";
import { PageEvent } from "@angular/material";
import { CustomerModel } from "../../common/viewModels/kyc/CustomerKycViewModel";
import { FormatService } from "../../common/formatService";
import { TestRatingTypesEnum } from "../../common/enumcontainer.enum";
import { Subject } from "rxjs/Subject";
import { BaseChartDirective } from "ng2-charts";
import { PagerService } from "../../common/pagerService";
import { JobCardsListModel } from "../../common/viewModels/Analysis/SampleModel";
declare var $: any;

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit, OnDestroy {
  pagedItems: any[] = [];
  customers: CustomerModel[] = [];
  lstJobCards: JobCardsListModel[] = [];
  searchForm: FormGroup;
  isNoRecords: boolean = true;
  hasFailureData: boolean = false;
  hasFleetHealthData: boolean = false;
  showSelectAllCustomers: boolean = true;
  isCustomerUser: boolean = false;
  currentUserDetails: any = null;
  
  // Filter Type Properties
  filterTypes: any[] = [
    { id: 1, name: 'Lab' },
    { id: 2, name: 'Customer' }
  ];
  selectedFilterTypeId: number = 1;

  // Publish Results Pagination
  length: number = 0;
  pageIndex: number = 0;
  pageNumber: number = 0;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10];
  pager: any = {};

  // Job Card Summary Pagination
  jobCardLength: number = 0;
  jobCardPageIndex: number = 0;
  jobCardPageSize: number = 10;
  jobCardPageSizeOptions: number[] = [10];
  jobCardPager: any = {};
  
  // Oil Grade Performance Pagination
  oilGradeLength: number = 0;
  oilGradePageIndex: number = 0;
  oilGradePageSize: number = 10;
  oilGradePageSizeOptions: number[] = [10];
  oilGradePager: any = {};
  
  // Critical Equipment Pagination
  criticalEquipmentLength: number = 0;
  criticalEquipmentPageIndex: number = 0;
  criticalEquipmentPageSize: number = 10;
  criticalEquipmentPageSizeOptions: number[] = [10];
  criticalEquipmentPager: any = {};
  
  private destroy$ = new Subject<void>();
  private isResetting = false;

  @ViewChild('pieChart') pieChart: BaseChartDirective;
  @ViewChild('failureChart') failureChart: BaseChartDirective;
  @ViewChild('parameterChart') parameterChart: BaseChartDirective;
  @ViewChild('monthwiseSampleHealthTrendChart') monthwiseSampleHealthTrendChart: BaseChartDirective;

  // Paginator references
  @ViewChild('publishResultsPaginator') publishResultsPaginator: any;
  @ViewChild('jobCardPaginator') jobCardPaginator: any;
  @ViewChild('oilGradePaginator') oilGradePaginator: any;
  @ViewChild('criticalEquipmentPaginator') criticalEquipmentPaginator: any;

  labTatSampleStatusData: any = {};
  criticalEquipmentData: any[] = [];
  oilgradePerformanceData: any[] = [];
  jobCardSummaryData: any[] = [];
  dashboardSampleReportCountData: any = [];
  failureCharacteristicsForDashboard: any = [];
  parameterCharacteristicsForDashboard: any = [];
  pieChartData: number[] = [];
  monthwiseSampleHealthTrendData: any[] = [];
  monthwiseSampleHealthTrendOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 750,
    },
    legend: {
      display: true,
      position: "top",
      labels: {
        usePointStyle: true,
        padding: 15,
        fontColor: "#000",
      },
    },
    scales: {
      xAxes: [{
        display: true,
        gridLines: {
          display: false,
        },
        ticks: {
          display: true,
          fontColor: "#000",
          fontSize: 11,
        },
      }],
      yAxes: [{
        display: true,
        stacked: false,
        gridLines: {
          color: "#BDBDBD",
        },
        ticks: {
          beginAtZero: true,
          fontColor: "#000",
        },
      }],
    },
  };
  monthwiseSampleHealthTrendLabels: string[] = [];
  constructor(
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
    private _formatService: FormatService,
    private _pagerService: PagerService,
    private cdr: ChangeDetectorRef,
  ) {}

  public pieChartLabels = ["Normal", "Marginal", "Critical"];

  public pieChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: "top",
    },
    labels: {
      usePointStyle: true,
      pointStyle: "circle",
    },
  };

  public pieChartColors: any[] = [
    {
      backgroundColor: [
        "#92d050", // Normal - Green
        "#f6a400", // Marginal - Yellow
        "#FF0000", // Critical - Red
      ],
    },
  ];

  public pieChartType = "pie";

  public failureChartType = "horizontalBar";

  public linearChartType = "line";

  public linearChartColors: any[] = [
    {
      backgroundColor: ["rgba(146, 208, 80, 0.15)", // Normal - Green
                        "rgba(246, 164, 0, 0.15)", // Marginal - Yellow
                        "rgba(255, 0, 0, 0.15)"], // Critical - Red
    }
  ];

  public failureChartLegend = false;

  ngOnInit() {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    this.currentUserDetails = curUserDetails;
    
    // Determine if user is a customer
    if (curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3) {
      this.isCustomerUser = true;
      this.showSelectAllCustomers = false;
    } else {
      this.isCustomerUser = false;
      this.showSelectAllCustomers = true;
    }
    
    this.GetCustomers();
    this.createSearchForm();
    
    // Initialize Publish Results Pager
    this.pageSize = 5;
    this.pager.pageSize = this.pageSize;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = [5];
    
    // Initialize Job Card Summary Pager
    this.jobCardPageSize = 5;
    this.jobCardPager.pageSize = this.jobCardPageSize;
    this.jobCardPager.pageIndex = 0;
    this.jobCardPager.pageSizeOptions = [5];
    
    // Initialize Oil Grade Performance Pager
    this.oilGradePageSize = 5;
    this.oilGradePager.pageSize = this.oilGradePageSize;
    this.oilGradePager.pageIndex = 0;
    this.oilGradePager.pageSizeOptions = [5];
    
    // Initialize Critical Equipment Pager
    this.criticalEquipmentPageSize = 5;
    this.criticalEquipmentPager.pageSize = this.criticalEquipmentPageSize;
    this.criticalEquipmentPager.pageIndex = 0;
    this.criticalEquipmentPager.pageSizeOptions = [5];

    // For customer users, bind job cards and auto-select the latest one
    if (this.isCustomerUser) {
      this.BindJobCard(this.searchForm.controls["CustomerId"].value, true).then(() => {
        this.InitializeDashboard();
      });
    } else {
      this.BindJobCard(this.searchForm.controls["CustomerId"].value, false).then(() => {
        this.InitializeDashboard();
      });
    }
  }

  InitializeDashboard() {
    this.GetLabTatSampleStatus();
    this.setPage(this.pager);
    this.setCriticalEquipmentPage(this.criticalEquipmentPager);
    this.GetDashboardMonthwiseSampleHealthTrend();
    this.setJobCardPage(this.jobCardPager);
    this.setOilGradePage(this.oilGradePager);
  }

  createSearchForm() {
    const today = new Date();
    const dateFrom = new Date(today.getFullYear(), today.getMonth() - 5, 1);
    const curUserDetails = this._mApp.getCurrentUserData(
      JSON.parse(localStorage.getItem("currentUser")).token,
    );
    this.searchForm = this._formBuilder.group({
      FilterTypeId: [1],
      CustomerId: [0],
      FromDate: [dateFrom],
      ToDate: [today],
      JobCardNumber: [[]],
    });
    if (curUserDetails && curUserDetails.DefaultCompanyId) {
      this.searchForm.controls["CustomerId"].setValue(
        parseInt(curUserDetails.DefaultCompanyId),
      );
    }
    // Initialize FilterTypeId to 1 for non-customer users, not shown for customer users
    if (!this.isCustomerUser) {
      this.searchForm.controls["FilterTypeId"].setValue(1);
      this.selectedFilterTypeId = 1;
    }
  }  GetCustomers() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCustomersMinInfoList)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          this.customers = data.json().Result;
          this._mApp.HideLoader();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  OnFilterTypeChange(filterTypeId: number) {
    this.selectedFilterTypeId = filterTypeId;
    
    if (filterTypeId === 1) {
      this.searchForm.controls["JobCardNumber"].setValue([]);
      const today = new Date();
      const dateFrom = new Date(today.getFullYear(), today.getMonth() - 5, 1);
      this.searchForm.patchValue({
        FromDate: dateFrom,
        ToDate: today,
        CustomerId: 0
      });
    } else if (filterTypeId === 2) {
      this.searchForm.controls["JobCardNumber"].setValue([]);
      this.searchForm.patchValue({
        FromDate: null,
        ToDate: null,
        CustomerId: 0
      });
    }
    
  }

  BindJobCard(val: any, autoSelect: boolean = false): Promise<boolean> {
    return new Promise((resolve) => {
      this._http.post(this._appUrl.GetJobCardsByCustomer, [val]).subscribe(
        (data) => {
          if (data.json().Result != null) {
            this.lstJobCards = data.json().Result;
            // Auto-select the latest job card for customer users
            // Assumes the API returns job cards ordered by most recent first
            if (autoSelect && this.lstJobCards.length > 0) {
              const latestJobCard = this.lstJobCards[0];
              const jobCardArray = [latestJobCard.JobCardNumber];
              this.searchForm.controls["JobCardNumber"].setValue(jobCardArray);
            }
          }
          resolve(true);  
        },
        (error) => {
          this._toastrService.error(error.json().Result);
          resolve(false);  
        },
      );
    });
  }

  GetLabTatSampleStatus() {
    this._mApp.ShowLoader();
    const selectedJobCards = this.searchForm.controls["JobCardNumber"].value || [];
    const dataToSend = {
      CustomerId: this.searchForm.value.CustomerId,
      FromDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.FromDate),
      ToDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.ToDate),
      JobCardIds: this.isCustomerUser || this.selectedFilterTypeId === 2 ? selectedJobCards : null,
    };
    
    this._http.post(this._appUrl.GetLabTatSampleStatus, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          this.labTatSampleStatusData = data.json().Result;
          this._mApp.HideLoader();
          // ✅ CALL THESE ONLY ONCE after main data is loaded
          this.GetDashboardSampleReportCount(dataToSend);
          this.GetFailureCharacteristicsForDashboard(dataToSend);
          this.GetParameterCharacteristicsForDashboard(dataToSend);
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  GetDashboardMonthwiseSampleHealthTrend() {
    const selectedJobCards = this.searchForm.value.JobCardNumber || [];
    const dataToSend = {
      CustomerId: this.searchForm.value.CustomerId,
      FromDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.FromDate),
      ToDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.ToDate),
      JobCardIds: this.isCustomerUser || this.selectedFilterTypeId === 2 ? selectedJobCards : null,
    };
    
    // ✅ CLEAR chart completely before fetching new data
    this.monthwiseSampleHealthTrendData = [];
    this.monthwiseSampleHealthTrendLabels = [];
    
    // ✅ Destroy existing chart if present to ensure clean slate
    if (this.monthwiseSampleHealthTrendChart && this.monthwiseSampleHealthTrendChart.chart) {
      this.monthwiseSampleHealthTrendChart.chart.destroy();
    }
    
    this._http
      .post(this._appUrl.GetDashboardMonthwiseSampleHealthTrend, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          const result = data.json().Result;
          
          if (!result || result.length === 0) {
            this.monthwiseSampleHealthTrendData = [];
            this.monthwiseSampleHealthTrendLabels = [];
            this.cdr.markForCheck();
            this.cdr.detectChanges();
            this._mApp.HideLoader();
            return;
          }
          
          // Map labels from result - based on new date range
          const labels = result.map((item) => item.Month);
          const normalData = result.map((item) => item.Normal);
          const marginalData = result.map((item) => item.Marginal);
          const criticalData = result.map((item) => item.Critical);
          
          
          // Create completely new dataset objects with spread operator for change detection
          this.monthwiseSampleHealthTrendData = [
            {
              label: "Normal",
              data: [...normalData],
              borderColor: "#92d050",
              backgroundColor: "rgba(146, 208, 80, 0.15)",
              pointBackgroundColor: "#92d050",
              pointBorderColor: "#ffffff",
              pointRadius: 6,
              pointHoverRadius: 8,
              borderWidth: 3,
              fill: false,
              lineTension: 0.4,
              spanGaps: true,
            },
            {
              label: "Marginal",
              data: [...marginalData],
              borderColor: "#f6a400",
              backgroundColor: "rgba(246, 164, 0, 0.15)",
              pointBackgroundColor: "#f6a400",
              pointBorderColor: "#ffffff",
              pointRadius: 6,
              pointHoverRadius: 8,
              borderWidth: 3,
              fill: false,
              lineTension: 0.4,
              spanGaps: true,
            },
            {
              label: "Critical",
              data: [...criticalData],
              borderColor: "#FF0000",
              backgroundColor: "rgba(255, 0, 0, 0.15)",
              pointBackgroundColor: "#FF0000",
              pointBorderColor: "#ffffff",
              pointRadius: 6,
              pointHoverRadius: 8,
              borderWidth: 3,
              fill: false,
              lineTension: 0.4,
              spanGaps: true,
            },
          ];
          
          // Update labels with NEW date range data
          this.monthwiseSampleHealthTrendLabels = [...labels];
          
          // ✅ FIX: Ensure all X-axis labels display for the selected date range
          this.monthwiseSampleHealthTrendOptions = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 750,
            },
            legend: {
              display: true,
              position: "top",
              labels: {
                usePointStyle: true,
                padding: 15,
                fontColor: "#000",
                fontSize: 12,
              },
            },
            scales: {
              xAxes: [{
                display: true,
                gridLines: {
                  display: false,
                  offsetGridLines: false,
                },
                ticks: {
                  display: true,
                  fontColor: "#000",
                  fontSize: 11,
                  autoSkip: false,  // ✅ CRITICAL: Show ALL labels, don't skip
                  maxRotation: 45,  // Allow rotation if needed
                  minRotation: 0,
                  padding: 10,
                },
              }],
              yAxes: [{
                display: true,
                stacked: false,
                gridLines: {
                  color: "#BDBDBD",
                  drawBorder: true,
                },
                ticks: {
                  beginAtZero: true,
                  fontColor: "#000",
                  fontSize: 11,
                },
              }],
            },
            layout: {
              padding: {
                left: 10,
                right: 10,
                top: 10,
                bottom: 20,  // ✅ Increased bottom padding for rotated labels
              },
            },
          };
          
          // ✅ Force Angular change detection
          this.cdr.markForCheck();
          this.cdr.detectChanges();
          
          // ✅ Re-render chart with new data and options
          setTimeout(() => {
            if (this.monthwiseSampleHealthTrendChart && 
                this.monthwiseSampleHealthTrendChart.chart) {
              // Ensure chart has latest data
              this.monthwiseSampleHealthTrendChart.chart.data.labels = this.monthwiseSampleHealthTrendLabels;
              this.monthwiseSampleHealthTrendChart.chart.data.datasets = this.monthwiseSampleHealthTrendData;
              this.monthwiseSampleHealthTrendChart.chart.options = this.monthwiseSampleHealthTrendOptions;
              
              // Update and redraw
              this.monthwiseSampleHealthTrendChart.chart.update();
              this.monthwiseSampleHealthTrendChart.chart.resize();
            }
          }, 200);
          
          this._mApp.HideLoader();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  GetDashboardSampleReportCount(dataToSend: any) {

    // ✅ Clear the pie chart before loading new data
    this.hasFleetHealthData = false;
    this.pieChartLabels = [];
    this.pieChartData = [];

    // Force Angular to remove the chart from the DOM
    this.cdr.detectChanges();

    // ✅ Destroy existing chart
    if (this.pieChart && this.pieChart.chart) {
      this.pieChart.chart.destroy();
    }

    this._http
      .post(this._appUrl.GetDashboardSampleReportCount, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          const response = data.json();
          this.dashboardSampleReportCountData = response.Result; 
          // Create NEW array references
          this.pieChartLabels = [
            `Normal (${this.dashboardSampleReportCountData.NormalPercent}%)`,
            `Marginal (${this.dashboardSampleReportCountData.MarginalPercent}%)`,
            `Critical (${this.dashboardSampleReportCountData.CriticalPercent}%)`,
          ];

          this.pieChartData = [
            Number(this.dashboardSampleReportCountData.Normal) || 0,
            Number(this.dashboardSampleReportCountData.Marginal) || 0,
            Number(this.dashboardSampleReportCountData.Critical) || 0,
          ];

          // Show chart only if data exists
          this.hasFleetHealthData =
            this.dashboardSampleReportCountData.TotalCount > 0;

          // Force Angular to recreate the chart
          this.cdr.detectChanges();

          // Refresh chart
          setTimeout(() => {
            if (this.pieChart) {
              this.pieChart.chart.update();
              this.pieChart.chart.resize();
            }
          }, 100);

          this._mApp.HideLoader();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        }
      );
  }

  public failureChartLabels: string[] = [];

  public failureChartData: any[] = [
    {
      data: [],
      // backgroundColor: "#2196F3",
    },
  ];

  public failureChartColors = [{
    backgroundColor: [
      '#3582ba',
      '#3582ba',
      '#3582ba',
      '#3582ba',
      '#3582ba',
      '#3582ba'
    ]
  }];
  
  public failureChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          ticks: {
            min: 0,
            max: 1,
            stepSize: 1,
          },
          scaleLabel: {
            display: true,
            labelString: "Number of Reports",
            fontColor: "#000000",
          },
          gridLines: {
            drawOnChartArea: false,
            color: "#BDBDBD",
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            drawOnChartArea: false,
            color: "#BDBDBD",
            barThickness: 14,
          },
          ticks: {
            fontColor: "#000000",
          },
        },
      ],
    },
  };

  // Parameter Characteristics Chart Variables
  public parameterChartLabels: string[] = [];
  public parameterChartType = "horizontalBar";
  public parameterChartLegend = true;
  public parameterChartData: any[] = [
    {
      label: "Normal",
      data: [],
      // backgroundColor: "#28A745",
    },
    {
      label: "Marginal",
      data: [],
      // backgroundColor: "#FFC107",
    },
    {
      label: "Critical",
      data: [],
      // backgroundColor: "#DC3545",
    },
  ];

  public parameterChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: "top",
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          ticks: {
            min: 0,
            max: 100,
            stepSize: 20,
            fontColor: "#000000",
          },
          scaleLabel: {
            display: true,
            labelString: "% of Samples",
            fontColor: "#000000",
          },
          gridLines: {
            drawOnChartArea: true,
            color: "#BDBDBD",
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false,
            color: "#BDBDBD",
          },
          ticks: {
            fontColor: "#000000",
          },
        },
      ],
    },
  };

  public parameterChartColors: any[] = [
    {
      backgroundColor: "#92d050",
      borderColor: "#92d050"
    },
    {
      backgroundColor: "#f6a400",
      borderColor: "#f6a400"
    },
    {
      backgroundColor: "#FF0000",
      borderColor: "#FF0000"
    }
  ];

  GetFailureCharacteristicsForDashboard(dataToSend: any) {
    // Create completely new array references
    this.failureChartLabels = [];
    this.failureChartData = [{ data: [], backgroundColor: "#2196F3" }];
    this.hasFailureData = false;
    
    this._http
      .post(this._appUrl.GetFailureCharacteristicsForDashboard, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          const response = data.json();
          this.failureCharacteristicsForDashboard = response.Result;
          
          
          // Check if data exists and is not empty
          if (!this.failureCharacteristicsForDashboard || this.failureCharacteristicsForDashboard.length === 0) {
            this.hasFailureData = false;
            
            // No data from API - create COMPLETELY NEW array references
            this.failureChartLabels = [];
            this.failureChartData = [{ data: [], backgroundColor: "#2196F3" }];
            
            this.failureChartOptions = {
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
              },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      min: 0,
                      max: 1,
                      stepSize: 1,
                    },
                    scaleLabel: {
                      display: true,
                      labelString: "Number of Reports",
                      fontColor: "#000000",
                    },
                    gridLines: {
                      drawOnChartArea: false,
                      color: "#BDBDBD",
                    },
                  },
                ],
                yAxes: [
                  {
                    gridLines: {
                      drawOnChartArea: false,
                      color: "#BDBDBD",
                      barThickness: 14,
                    },
                    ticks: {
                      fontColor: "#000000",
                    },
                  },
                ],
              },
            };
            
            
            // Force change detection immediately
            this.cdr.markForCheck();
            this.cdr.detectChanges();
            
            // Destroy and recreate chart
            setTimeout(() => {
              if (this.failureChart && this.failureChart.chart) {
                this.failureChart.chart.destroy();
              }
              this.cdr.detectChanges();
            }, 50);
            
            this._mApp.HideLoader();
            return;
          }
          
          this.hasFailureData = true;
          
          // Data exists - populate chart with NEW array references
          const newLabels = [];
          this.failureCharacteristicsForDashboard.forEach((x: any) => {
            newLabels.push(`${x.CharacteristicName} (${x.FailureSamplesCount})`);
          });
          this.failureChartLabels = newLabels;
          
          const maxvalue = this.failureCharacteristicsForDashboard.reduce(
            (max: any, item: any) => Math.max(max, item.FailureSamplesCount),
            0,
          );
          const stepSize = Math.ceil(Math.ceil(maxvalue) / 5);
          this.failureChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    min: 0,
                    max: maxvalue,
                    stepSize: stepSize,
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Number of Reports",
                    fontColor: "#000000",
                  },
                  gridLines: {
                    drawOnChartArea: false,
                    color: "#BDBDBD",
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    drawOnChartArea: false,
                    color: "#BDBDBD",
                    barThickness: 14,
                  },
                  ticks: {
                    fontColor: "#000000",
                  },
                },
              ],
            },
          };

          const newData = this.failureCharacteristicsForDashboard.map((x: any) => x.FailureSamplesCount);
          this.failureChartData = [
            {
              data: newData,
              backgroundColor: "#2196F3",
            },
          ];


          // Force change detection
          this.cdr.markForCheck();
          this.cdr.detectChanges();

          // Refresh chart after data update
          setTimeout(() => {
            if (this.failureChart && this.failureChart.chart) {
              this.failureChart.chart.resize();
              this.failureChart.chart.update();
            }
          }, 100);

          this._mApp.HideLoader();
        },
        (error) => {
          console.error("Error fetching failure characteristics:", error);
          this.hasFailureData = false;
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  GetParameterCharacteristicsForDashboard(dataToSend: any) {
    // Reset chart data
    this.parameterChartLabels = [];
    this.parameterChartData = [
      { label: "Normal", data: [], backgroundColor: "#28A745" },
      { label: "Marginal", data: [], backgroundColor: "#FFC107" },
      { label: "Critical", data: [], backgroundColor: "#DC3545" },
    ];

    this._http
      .post(this._appUrl.GetParameterCharacteristicsForDashboard, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          const response = data.json();
          this.parameterCharacteristicsForDashboard = response.Result;


          if (!this.parameterCharacteristicsForDashboard || this.parameterCharacteristicsForDashboard.length === 0) {
            this.parameterChartLabels = [];
            this.parameterChartData = [
              { label: "Normal", data: [], backgroundColor: "#28A745" },
              { label: "Marginal", data: [], backgroundColor: "#FFC107" },
              { label: "Critical", data: [], backgroundColor: "#DC3545" },
            ];
            this.cdr.markForCheck();
            this.cdr.detectChanges();
            this._mApp.HideLoader();
            return;
          }

          // Populate labels with characteristic names and percentages
          const newLabels = this.parameterCharacteristicsForDashboard.map((x: any) => x.CharacteristicName);
          this.parameterChartLabels = newLabels;

          // Populate data for each status (Normal, Marginal, Critical)
          const normalData = this.parameterCharacteristicsForDashboard.map((x: any) => x.NormalPercent || 0);
          const marginalData = this.parameterCharacteristicsForDashboard.map((x: any) => x.MarginalPercent || 0);
          const criticalData = this.parameterCharacteristicsForDashboard.map((x: any) => x.CriticalPercent || 0);

          this.parameterChartData = [
            { label: "Normal", data: normalData, backgroundColor: "#28A745" },
            { label: "Marginal", data: marginalData, backgroundColor: "#FFC107" },
            { label: "Critical", data: criticalData, backgroundColor: "#DC3545" },
          ];

          // Force change detection
          this.cdr.markForCheck();
          this.cdr.detectChanges();

          // Refresh chart after data update
          setTimeout(() => {
            if (this.parameterChart && this.parameterChart.chart) {
              this.parameterChart.chart.resize();
              this.parameterChart.chart.update();
            }
          }, 100);

          this._mApp.HideLoader();
        },
        (error) => {
          console.error("Error fetching parameter characteristics:", error);
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  setCriticalEquipmentPage(page: any) {
    this.criticalEquipmentPager.pageSize = page.pageSize;
    this.criticalEquipmentPager.pageIndex = page.pageIndex;
    this.GetCriticalEquipments(this.criticalEquipmentPager);
  }

  GetCriticalEquipments(page?: any) {
    this._mApp.ShowLoader();
    const pageInfo = page || this.criticalEquipmentPager;
    const selectedJobCards = this.searchForm.value.JobCardNumber || [];
    const dataToSend = {
      CustomerId: this.searchForm.value.CustomerId,
      FromDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.FromDate),
      ToDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.ToDate),
      JobCardIds: this.isCustomerUser || this.selectedFilterTypeId === 2 ? selectedJobCards : null,
      PageNo: pageInfo.pageIndex,
      PageSize: pageInfo.pageSize,
    };
    this._http
      .post(this._appUrl.GetCriticalEquipmentsRequiringAction, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          const response = data.json();
          this.criticalEquipmentData = response.Result;
          this.criticalEquipmentLength = response.PageResult ? response.PageResult.TotalRecords : 0;
          this._mApp.HideLoader();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  getStatusClass(status: string): string {
    switch (status) {
      case "Critical":
        return "chip-critical";
      case "Marginal":
        return "chip-marginal";
      case "Normal":
        return "chip-normal";
      default:
        return "chip-default";
    }
  }

  OnSubmit() {
    // ✅ SINGLE CALL - Prevent duplicate API calls
    if (this.isResetting) {
      return;
    }
    this.isResetting = true;

    // Reset Publish Results Pagination
    this.pager.pageIndex = 0;
    this.pageIndex = 0;
    this.pageNumber = 0;
    if (this.publishResultsPaginator) {
      this.publishResultsPaginator.pageIndex = 0;
    }
    
    // Reset Job Card Summary Pagination
    this.jobCardPager.pageIndex = 0;
    this.jobCardPageIndex = 0;
    if (this.jobCardPaginator) {
      this.jobCardPaginator.pageIndex = 0;
    }
    
    // Reset Oil Grade Performance Pagination
    this.oilGradePager.pageIndex = 0;
    this.oilGradePageIndex = 0;
    if (this.oilGradePaginator) {
      this.oilGradePaginator.pageIndex = 0;
    }
    
    // Reset Critical Equipment Pagination
    this.criticalEquipmentPager.pageIndex = 0;
    this.criticalEquipmentPageIndex = 0;
    if (this.criticalEquipmentPaginator) {
      this.criticalEquipmentPaginator.pageIndex = 0;
    }
    
    // ✅ Call GetLabTatSampleStatus once - it will call other methods internally
    this.GetLabTatSampleStatus();
    this.setPage(this.pager);
    this.GetCriticalEquipments();
    this.GetDashboardMonthwiseSampleHealthTrend();
    this.setJobCardPage(this.jobCardPager);
    this.setOilGradePage(this.oilGradePager);
    this.setCriticalEquipmentPage(this.criticalEquipmentPager);

    // ✅ Reset flag after debounce delay
    setTimeout(() => {
      this.isResetting = false;
    }, 1000);
  }

  OnRefresh() {
    // ✅ SINGLE CALL - Prevent duplicate API calls
    if (this.isResetting) {
      return;
    }
    this.isResetting = true;

    // Reset Publish Results Pagination
    this.pager.pageIndex = 0;
    this.pageIndex = 0;
    this.pageNumber = 0;
    if (this.publishResultsPaginator) {
      this.publishResultsPaginator.pageIndex = 0;
    }
    
    // Reset Job Card Summary Pagination
    this.jobCardPager.pageIndex = 0;
    this.jobCardPageIndex = 0;
    if (this.jobCardPaginator) {
      this.jobCardPaginator.pageIndex = 0;
    }
    
    // Reset Oil Grade Performance Pagination
    this.oilGradePager.pageIndex = 0;
    this.oilGradePageIndex = 0;
    if (this.oilGradePaginator) {
      this.oilGradePaginator.pageIndex = 0;
    }
    
    // Reset Critical Equipment Pagination
    this.criticalEquipmentPager.pageIndex = 0;
    this.criticalEquipmentPageIndex = 0;
    if (this.criticalEquipmentPaginator) {
      this.criticalEquipmentPaginator.pageIndex = 0;
    }

    if(this.selectedFilterTypeId === 2) {
      this.searchForm = this._formBuilder.group({
        FilterTypeId: [2],
      CustomerId: [0],
      FromDate: [null],
      ToDate: [null],
      JobCardNumber: [[]],
     });
     this.isResetting = false;
     return;
    }
      
    
    this.createSearchForm();
    
    // For customer users, bind job cards and auto-select the latest one
    if (this.isCustomerUser) {
      this.BindJobCard(this.searchForm.controls["CustomerId"].value, true).then(() => {
        // ✅ Call GetLabTatSampleStatus once - it will call other methods internally
        this.GetLabTatSampleStatus();
        this.setPage(this.pager);
        this.GetCriticalEquipments();
        this.GetDashboardMonthwiseSampleHealthTrend();
        this.setJobCardPage(this.jobCardPager);
        this.setOilGradePage(this.oilGradePager);
        this.setCriticalEquipmentPage(this.criticalEquipmentPager);

        // ✅ Reset flag after debounce delay
        setTimeout(() => {
          this.isResetting = false;
        }, 1000);
      });
    } else {
      this.BindJobCard(this.searchForm.controls["CustomerId"].value, false).then(() => {
        // ✅ Call GetLabTatSampleStatus once - it will call other methods internally
        this.GetLabTatSampleStatus();
        this.setPage(this.pager);
        this.GetCriticalEquipments();
        this.GetDashboardMonthwiseSampleHealthTrend();
        this.setJobCardPage(this.jobCardPager);
        this.setOilGradePage(this.oilGradePager);
        this.setCriticalEquipmentPage(this.criticalEquipmentPager);

        // ✅ Reset flag after debounce delay
        setTimeout(() => {
          this.isResetting = false;
        }, 1000);
      });
    }
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetPublishResults(this.pager);
  }

  GetPublishResults(page?: any) {
      const pageInfo = page || this.pager;
      const selectedJobCards = this.searchForm.value.JobCardNumber || [];
      const request = {
        CustomerId: this.searchForm.value.CustomerId || 0,
        PublishedDateFrom: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.FromDate),
        PublishedDateTo: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.ToDate),
        JobCardIds: this.isCustomerUser || this.selectedFilterTypeId === 2 ? selectedJobCards : null,
        PageNo: pageInfo.pageIndex,
        PageSize: pageInfo.pageSize
      };
      this._mApp.ShowLoader();
      this._http.post(this._appUrl.GetPublishedResults, request)
          .takeUntil(this.destroy$)
          .subscribe(
              res => {
                  this._mApp.HideLoader();
                  const data = res.json();
                  this.length = data.PageResult.TotalRecords;
                  this.pagedItems = data.Result;
                  this.isNoRecords = !(data.Result.length > 0);
              },
              error => {
                  this._mApp.HideLoader();
                  this._toastrService.error(error.json().Result, '');
              }
          );
  }
    
    getPdfColor(ratingId: number): string {
        return this.ratingConfig[ratingId] ? this.ratingConfig[ratingId].color : '#BDBDBD';
    }

    getPdfIconTitle(ratingId: number): string {
        return this.ratingConfig[ratingId] ? this.ratingConfig[ratingId].title : 'Normal';
    }

    private readonly ratingConfig = {
        [TestRatingTypesEnum.Critical]: {
            color: '#FF0000',
            title: 'Critical'
        },
        [TestRatingTypesEnum.Marginal]: {
            color: '#FFC000',
            title: 'Marginal'
        },
        [TestRatingTypesEnum.Normal]: {
            color: '#70AD47',
            title: 'Normal'
        }
    };

    DownloadFile(id) {
      this._mApp.ShowLoader();
      this._http.get(this._appUrl.GetSampleReportById + id)
        .takeUntil(this.destroy$)
        .subscribe(
          res => {
            this._mApp.HideLoader();
            var data = res.json().Result;
            this._mApp.DownloadFile(data);
          },
          error => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, '');
          }
        );
    }

  setOilGradePage(page: any) {
    this.oilGradePager.pageSize = page.pageSize;
    this.oilGradePager.pageIndex = page.pageIndex;
    this.GetOilGradePerformanceList(this.oilGradePager);
  }

  GetOilGradePerformanceList(page?: any) {
    this._mApp.ShowLoader();
    const pageInfo = page || this.oilGradePager;
    const selectedJobCards = this.searchForm.value.JobCardNumber || [];
    const dataToSend = {
      CustomerId: this.searchForm.value.CustomerId,
      FromDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.FromDate),
      ToDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.ToDate),
      JobCardIds: this.isCustomerUser || this.selectedFilterTypeId === 2 ? selectedJobCards : null,
      PageNo: pageInfo.pageIndex,
      PageSize: pageInfo.pageSize,
    };
    this._http
      .post(this._appUrl.GetOilGradePerformance, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          const response = data.json();
          this.oilgradePerformanceData = response.Result;
          this.oilGradeLength = response.PageResult.TotalRecords;
          this._mApp.HideLoader();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  setJobCardPage(page: any) {
    this.jobCardPager.pageSize = page.pageSize;
    this.jobCardPager.pageIndex = page.pageIndex;
    this.GetJobCardSummaryList(this.jobCardPager);
  }

  GetJobCardSummaryList(page?: any) {
    this._mApp.ShowLoader();
    const pageInfo = page || this.jobCardPager;
    const selectedJobCards = this.searchForm.value.JobCardNumber || [];
    const dataToSend = {
      CustomerId: this.searchForm.value.CustomerId,
      FromDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.FromDate),
      ToDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.ToDate),
      JobCardIds: this.isCustomerUser || this.selectedFilterTypeId === 2 ? selectedJobCards : null,
      PageNo: pageInfo.pageIndex,
      PageSize: pageInfo.pageSize,
    };
    this._http
      .post(this._appUrl.GetJobCardSummary, dataToSend)
      .takeUntil(this.destroy$)
      .subscribe(
        (data) => {
          const response = data.json();
          this.jobCardSummaryData = response.Result;
          this.jobCardLength = response.PageResult.TotalRecords;
          this._mApp.HideLoader();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  ExportDashboardPDF() {
    this._mApp.ShowLoader();
    const selectedJobCards = this.searchForm.value.JobCardNumber || [];
    const dataToSend = {
      CustomerId: this.searchForm.value.CustomerId,
      FromDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.FromDate),
      ToDate: this.isCustomerUser || this.selectedFilterTypeId === 2 ? null : this._formatService.formatDate(this.searchForm.value.ToDate),
      JobCardIds: this.isCustomerUser || this.selectedFilterTypeId === 2 ? selectedJobCards : null,
      PageNo: 1,
      PageSize: 100,
    };
    this._http.post(this._appUrl.DownloadDashboardPDF, dataToSend)
      .subscribe(
                res => {
                    var data = res.json().Result;
                    window.open(res.json().Result, '_blank');
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
  }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
}